import { FunctionsHttpError, SupabaseClient } from '@supabase/supabase-js';

export async function invokeEdgeFunction<T = unknown>(
  supabase: SupabaseClient,
  functionName: string,
  options?: Parameters<SupabaseClient['functions']['invoke']>[1]
): Promise<T> {
  const { data, error } = await supabase.functions.invoke(functionName, options);

  if (error) {
    if (error instanceof FunctionsHttpError) {
      const body = await error.context.json();
      throw new Error(body.error ?? error.message);
    }
    throw new Error(typeof error === 'string' ? error : (error as Error).message);
  }

  return data as T;
}
